import decode from 'jwt-decode';
import { parse } from 'qs';
import { OAuthConfig } from '@chr/common-web-ui-authentication/authClientTypes';

const INTERNAL_USER_KEY = 'NavisphereInsightInternalUser';

interface HashOptions {
  impersonate?: any;
  access_token?: string;
}

interface AccessToken {
  cid?: string;
}

export const authClientOptions = (
  config: IAppConfig
): Partial<OAuthConfig> | null => {
  // the pathname ends with "/impersonate" or "/impersonate/"
  const hasImpersonatePath = /.*\/impersonate\/?$/.test(
    window.location.pathname
  );
  const hashStr = window.location.hash.replace(/^#?\/?/, '');
  const parsedQs: HashOptions = parse(hashStr);

  const hasImpersonateHash = parsedQs.hasOwnProperty('impersonate');

  const hasInternalAccessToken =
    parsedQs.hasOwnProperty('access_token') &&
    parsedQs.access_token != null &&
    decode<AccessToken>(parsedQs.access_token).cid ===
      config.oAuthClientIdInternal;

  // if the app is loaded with the internal hash,
  // has the internal Okta client ID in the access_token,
  // or internal user is set in the session storage key
  if (
    hasImpersonatePath ||
    hasImpersonateHash ||
    hasInternalAccessToken ||
    sessionStorage.getItem(INTERNAL_USER_KEY) === 'true'
  ) {
    sessionStorage.setItem(INTERNAL_USER_KEY, 'true');

    return {
      domain: config.oAuthDomainInternal,
      audience: config.oAuthAudienceInternal,
      clientId: config.oAuthClientIdInternal,
      scopes: ['openid', 'profile', 'email', 'cfa.insight'],
    };
  }
  return null;
};
